import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchMedicineByBrand } from "../../services/HomePage/BrandDetails";
import { FaFilter } from "react-icons/fa";

export default function GetMedicineByBrand() {
  const { brandId } = useParams();
  const navigate = useNavigate();

  const [medicines, setMedicines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFilter, setShowFilter] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await fetchMedicineByBrand(Number(brandId));
        setMedicines(data);
      } catch (err) {
        console.error("Medicine Fetch Error:", err);
      }
      setLoading(false);
    };
    load();
  }, [brandId]);

  return (
    <div className="container-fluid" style={{ minHeight: "100vh" }}>
      
      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center px-3 py-3 bg-white border-bottom">
        <h5 className="fw-bold m-0">Medicines by Brand</h5>
        <button className="btn btn-outline-danger" onClick={() => setShowFilter(true)}>
          <FaFilter /> Filters
        </button>
      </div>

      {/* LOADING */}
      {loading && (
        <div className="text-center mt-5">
          <div className="spinner-border text-danger"></div>
        </div>
      )}

      {/* GRID */}
      {!loading && (
        <div className="container py-4">
          <div className="row g-4">
            {medicines.length === 0 && (
              <p className="text-center text-muted">No medicines found</p>
            )}

            {medicines.map((med) => (
              <div
                key={med.id}
                className="col-6 col-sm-6 col-md-4 col-lg-3"
                onClick={() => navigate(`/medicinedetails/${med.id}`)}
                style={{ cursor: "pointer" }}
              >
                <div className="shadow-sm p-3 bg-white rounded h-100">
                  <div
                    style={{
                      height: "150px",
                      background: "#f5f5f5",
                      borderRadius: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={med.image}
                      alt={med.name}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>

                  <h6 className="fw-bold mt-2 text-truncate">
                    {med.name}
                  </h6>

                  <p className="text-muted m-0" style={{ fontSize: "13px" }}>
                    {med.saltName}
                  </p>

                  {med.strength && (
                    <p className="m-0">
                      Strength: <strong>{med.strength}</strong>
                    </p>
                  )}

                  {med.isPrescription && (
                    <span className="badge bg-warning text-dark mt-2">
                      Prescription Required
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* RIGHT FILTER SLIDER */}
      {showFilter && (
        <>
          {/* OVERLAY */}
          <div
            onClick={() => setShowFilter(false)}
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.5)",
              zIndex: 1045,
            }}
          />

          {/* SLIDE PANEL */}
          <div
            style={{
              position: "fixed",
              top: 0,
              right: 0,
              width: "340px",
              height: "100vh",
              background: "#fff",
              zIndex: 1050,
              padding: "22px",
              boxShadow: "-2px 0 10px rgba(0,0,0,0.2)",
              animation: "slideIn .3s ease forwards",
            }}
          >
            <h5 className="fw-bold mb-3">Filters</h5>

            <hr />

            <p className="fw-semibold">Strength</p>
            <div className="d-flex flex-wrap gap-2 mb-3">
              <button className="btn btn-sm btn-outline-danger">250mg</button>
              <button className="btn btn-sm btn-outline-danger">500mg</button>
              <button className="btn btn-sm btn-outline-danger">650mg</button>
            </div>

            <p className="fw-semibold">Type</p>
            <div className="form-check mb-2">
              <input type="checkbox" className="form-check-input" id="tablets" />
              <label className="form-check-label" htmlFor="tablets">Tablet</label>
            </div>

            <div className="form-check mb-2">
              <input type="checkbox" className="form-check-input" id="capsules" />
              <label className="form-check-label" htmlFor="capsules">Capsule</label>
            </div>

            <button className="btn btn-danger w-100 mt-4" onClick={() => setShowFilter(false)}>
              Apply Filters
            </button>
          </div>
        </>
      )}

      {/* SLIDE ANIMATION */}
      <style>{`
        @keyframes slideIn {
          from { transform: translateX(100%); }
          to { transform: translateX(0%); }
        }
      `}</style>
    </div>
  );
}
